import React from 'react';
import { aboutContent } from '../data/mock';
import { CheckCircle2, Award, Shield, Clock, ThumbsUp } from 'lucide-react';

const highlightIcons = [Clock, Shield, Award, ThumbsUp];

const About = () => {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left: Image/Visual */}
          <div className="relative">
            <div className="relative aspect-[4/3] rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://customer-assets.emergentagent.com/job_swim-solutions-9/artifacts/ecuh1n7c_WhatsApp%20Image%202026-02-08%20at%2011.54.57%20%282%29.jpeg"
                alt="Beautiful pool by TT Pools"
                className="w-full h-full object-cover"
              />
              {/* Overlay gradient */}
              <div className="absolute inset-0 bg-gradient-to-tr from-blue-900/40 to-transparent" />
            </div>
            
            {/* Floating card */}
            <div className="absolute -bottom-8 -right-4 sm:right-8 bg-white rounded-2xl shadow-xl p-6 max-w-xs">
              <div className="flex items-center gap-4">
                <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-cyan-500 to-blue-600 flex items-center justify-center flex-shrink-0">
                  <Award className="w-7 h-7 text-white" />
                </div>
                <div>
                  <div className="text-2xl font-bold text-slate-800">20+</div>
                  <div className="text-sm text-slate-500">Years of Excellence</div>
                </div>
              </div>
            </div>

            {/* Decorative element */}
            <div className="absolute -z-10 -top-8 -left-8 w-64 h-64 bg-cyan-100 rounded-full blur-3xl opacity-60" />
          </div>

          {/* Right: Content */}
          <div className="space-y-8">
            <div>
              <span className="inline-block px-4 py-1.5 rounded-full bg-cyan-100 text-cyan-700 text-sm font-semibold mb-4">
                About Us
              </span>
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-slate-800 mb-6">
                Your Trusted Partner in{' '}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-500 to-blue-600">
                  Pool Excellence
                </span>
              </h2>
            </div>

            <div className="space-y-4 text-slate-600 leading-relaxed">
              {aboutContent.description.split('\n\n').map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))}
            </div>

            {/* Highlights */}
            <div className="grid grid-cols-2 gap-4 pt-4">
              {aboutContent.highlights.map((highlight, index) => {
                const IconComponent = highlightIcons[index] || CheckCircle2;
                return (
                  <div
                    key={index}
                    className="flex items-center gap-3 p-4 rounded-xl bg-slate-50 hover:bg-cyan-50 transition-colors group"
                  >
                    <div className="w-10 h-10 rounded-lg bg-white shadow-sm flex items-center justify-center group-hover:bg-cyan-100 transition-colors">
                      <IconComponent className="w-5 h-5 text-cyan-600" />
                    </div>
                    <span className="text-sm font-medium text-slate-700">{highlight}</span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
